/* eslint-disable */
import Swiper from 'swiper';
import { A11y, Keyboard, Navigation, Pagination } from 'swiper/modules';

export default function newsSlider() {
  const imageSliders = document.querySelectorAll('.news-slider');

  imageSliders.forEach((imageSlider) => {
    const slider = new Swiper(imageSlider, {
      modules: [A11y, Keyboard, Navigation, Pagination],
      loop: true,
      spaceBetween: 22,
      slidesPerView: 1,
      keyboard: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        addIcons: false,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      a11y: {
        scrollOnFocus: false,
      },
      breakpoints: {
        1024: {
          slidesPerView: 2,
        }
      },
      watchSlidesProgress: true,
      on: {
        slideChange: (swiper) => {
          swiper.slides.forEach((slide) => {
            if (slide.classList.contains('swiper-slide-visible')) {
              slide.removeAttribute('inert');
            } else {
              slide.setAttribute('inert', '');
            }
          });
        }
      }
    });
  });
}
